import { render, staticRenderFns } from "./fangaiEdit.vue?vue&type=template&id=58e84b18&scoped=true&"
import script from "./fangaiEdit.vue?vue&type=script&lang=js&"
export * from "./fangaiEdit.vue?vue&type=script&lang=js&"
import style0 from "./fangaiEdit.vue?vue&type=style&index=0&id=58e84b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e84b18",
  null
  
)

export default component.exports